import HttpRepository from './httpRepository';

type ProfileOptions = {
	profileId: string;
};

type ProfileForCompanyOptions = {
	companyId: string;
};

type ProfileWithCompanyOptions = {
	companyId: string;
	profileId: string;
};

const RequestProfilesRepository = {
	getProfiles: (): Promise<any> =>
		HttpRepository.tradeshiftGo()
			.get('/rest/requestProfiles')
			.then(response => response.data),

	getProfile: (options: ProfileOptions): Promise<any> =>
		HttpRepository.tradeshiftGo().get('/rest/requestProfiles/' + options.profileId),

	getRequestProfilesForCompany: (options: ProfileForCompanyOptions): Promise<any> =>
		HttpRepository.tradeshiftGo()
			.get('/rest/company/' + options.companyId + '/requestProfiles')
			.then(response => response.data),

	setProfileForCompany: (options: ProfileWithCompanyOptions): Promise<any> =>
		HttpRepository.tradeshiftGo().put('/rest/company/' + options.companyId + '/requestProfiles/' + options.profileId),

	removeProfileFromCompany: (options: ProfileForCompanyOptions): Promise<any> =>
		HttpRepository.tradeshiftGo().delete('/rest/company/' + options.companyId + '/requestProfiles'),
};

export default RequestProfilesRepository;
